import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-overlay"
}
const _hoisted_2 = { class: "modal-content resizable-modal" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = ["value"]
const _hoisted_7 = {
  key: 0,
  class: "model-description"
}
const _hoisted_8 = { class: "form-group schedule-checkbox-row" }
const _hoisted_9 = {
  key: 0,
  class: "form-group"
}
const _hoisted_10 = {
  key: 0,
  class: "schedule-help-text"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 1,
  class: "schedule-error-text"
}
const _hoisted_13 = { class: "schedule-usage-text" }
const _hoisted_14 = { class: "modal-actions-fixed" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "modal-close",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onCancel && _ctx.onCancel(...args))),
            "aria-label": "Close"
          }, _cache[10] || (_cache[10] = [
            _createElementVNode("svg", {
              width: "24",
              height: "24",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "aria-hidden": "true"
            }, [
              _createElementVNode("line", {
                x1: "18",
                y1: "6",
                x2: "6",
                y2: "18"
              }),
              _createElementVNode("line", {
                x1: "6",
                y1: "6",
                x2: "18",
                y2: "18"
              })
            ], -1)
          ])),
          _cache[18] || (_cache[18] = _createElementVNode("h2", null, "Panel Settings", -1)),
          _createElementVNode("form", {
            onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onUpdate && _ctx.onUpdate(...args)), ["prevent"])),
            class: "settings-form"
          }, [
            _createElementVNode("div", _hoisted_3, [
              _cache[11] || (_cache[11] = _createElementVNode("label", { for: "title" }, "Title", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "title",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.title) = $event)),
                type: "text",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.form.title]
              ])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _cache[12] || (_cache[12] = _createElementVNode("label", { for: "instructions" }, "Instructions", -1)),
              _withDirectives(_createElementVNode("textarea", {
                id: "instructions",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.instructions) = $event)),
                rows: "3"
              }, null, 512), [
                [_vModelText, _ctx.form.instructions]
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _cache[14] || (_cache[14] = _createElementVNode("label", { for: "model" }, "LLM Model", -1)),
              _withDirectives(_createElementVNode("select", {
                id: "model",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.agentType) = $event))
              }, [
                _cache[13] || (_cache[13] = _createElementVNode("option", { value: "" }, "Select a model...", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableModels, (model) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: model.id,
                    value: model.id
                  }, _toDisplayString(model.displayName) + " (" + _toDisplayString(model.modelName) + ") ", 9, _hoisted_6))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.form.agentType]
              ]),
              (_ctx.selectedModelDescription)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.selectedModelDescription), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.scheduleEnabled) = $event)),
                id: "scheduled-updates-checkbox",
                class: "schedule-checkbox"
              }, null, 512), [
                [_vModelCheckbox, _ctx.form.scheduleEnabled]
              ]),
              _cache[15] || (_cache[15] = _createElementVNode("label", {
                for: "scheduled-updates-checkbox",
                class: "schedule-label"
              }, "Scheduled updates", -1))
            ]),
            (_ctx.form.scheduleEnabled)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _withDirectives(_createElementVNode("input", {
                    id: "schedule",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.scheduleText) = $event)),
                    type: "text",
                    placeholder: "e.g. Every Monday at 9am",
                    onInput: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.updateCron && _ctx.updateCron(...args)))
                  }, null, 544), [
                    [_vModelText, _ctx.form.scheduleText]
                  ]),
                  (_ctx.form.cronString)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        (_ctx.humanSummary)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.humanSummary), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : (_ctx.form.scheduleText)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _cache[16] || (_cache[16] = _createTextVNode(" Could not parse schedule.")),
                          _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1)),
                          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.usageString), 1)
                        ]))
                      : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ], 32),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onCancel && _ctx.onCancel(...args)))
            }, "Cancel"),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onUpdate && _ctx.onUpdate(...args)))
            }, "Update")
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}